import { TFunction } from "i18next";
import * as yup from "yup";

export interface TermsOfUse {
  enabled: boolean;
  text: string;
}

export const createTermsOfUse = (
  enabled: boolean = false,
  text: string = "",
) => ({
  enabled: enabled,
  text: text,
});

export const TermsOfUseValidation = (t: TFunction) =>
  yup.object().shape({
    enabled: yup.boolean(),
    text: yup.string(),
  });
